module.exports = __webpack_public_path__ + "static/media/axial-length-illustration.36f6077b.png";